/**
 * Filters the product media gallery to the selected color's images.
 *
 * Only thumbnails (and, in stacked layouts, the media items) are hidden/shown
 * by matching their alt text to the selected color. The main "active" image is
 * left entirely to Dawn, which already swaps to the variant's featured image —
 * managing it here as well caused a double-update flash on color change.
 */
(function () {
  const COLOR_OPTION_NAMES = ['color', 'colour', 'farbe', 'couleur'];
  const HIDDEN_CLASS = 'variant-color-hidden';

  function isColorOption(name) {
    const normalized = name.toLowerCase().replace(/[^a-z]/g, '');
    return COLOR_OPTION_NAMES.some((candidate) => normalized.includes(candidate));
  }

  function getSelectedColor() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return null;

    const checked = variantSelects.querySelectorAll('input[type="radio"]:checked');
    for (const input of checked) {
      const fieldset = input.closest('fieldset');
      const legend = fieldset && fieldset.querySelector('legend, .form__label');
      if (legend && isColorOption(legend.textContent)) {
        return input.value;
      }
    }
    return null;
  }

  /**
   * @param {string} colorValue selected color name
   * @param {boolean} includeMedia also filter the main media items. Only safe
   *   once Dawn has set the new variant's image active, otherwise the currently
   *   active (old color) image would be hidden and blank the viewer.
   */
  function filterByColor(colorValue, includeMedia) {
    if (!colorValue) return;
    const color = colorValue.toLowerCase().trim();
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    let visibleThumbs = 0;
    gallery.querySelectorAll('.thumbnail-list__item[data-media-alt]').forEach((item) => {
      const matches = (item.dataset.mediaAlt || '').toLowerCase().includes(color);
      item.classList.toggle(HIDDEN_CLASS, !matches);
      if (matches) visibleThumbs += 1;
    });

    if (includeMedia) {
      gallery.querySelectorAll('.product__media-item[data-media-alt]').forEach((item) => {
        const matches = (item.dataset.mediaAlt || '').toLowerCase().includes(color);
        item.classList.toggle(HIDDEN_CLASS, !matches);
      });
    }

    const counterTotal = gallery.querySelector('.slider-counter--total');
    if (counterTotal && visibleThumbs > 0) counterTotal.textContent = visibleThumbs;
  }

  function applyFull() {
    filterByColor(getSelectedColor(), true);
  }

  function init() {
    // Instant feedback: hide other colors' thumbnails the moment a color is
    // clicked. Media items are left alone here so the active image doesn't blank
    // before Dawn swaps it.
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target && target.type === 'radio' && target.closest('variant-selects')) {
        filterByColor(getSelectedColor(), false);
      }
    });

    // Authoritative pass once Dawn has finished re-rendering the gallery.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.requestAnimationFrame(applyFull);
      });
    }

    document.addEventListener('shopify:section:load', applyFull);

    applyFull();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();